var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCloud32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 3.62601V5.54029C26 5.88611 25.7247 6.1663 25.385 6.1663H22.8478C20.3569 6.1663 18.3068 8.12858 18.1133 10.616C18.096 10.8335 17.9179 11 17.7043 11H15.4135C15.1729 11 14.9881 10.7923 15.0006 10.5474C15.2306 6.3397 18.6562 3 22.8478 3H25.385C25.7247 3 26 3.28019 26 3.62601Z",
    fill: "url(#paint0_linear_45_35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2173 25.9421C11.3581 25.9421 9.03974 23.6099 9.03974 20.7337V20.2654C9.03974 17.3891 11.3581 15.0569 14.2173 15.0569H17.7395C18.0357 15.0569 18.2765 15.2991 18.2765 15.5972V17.6153C18.2765 17.9133 18.5173 18.1555 18.8135 18.1555H20.8197C21.1159 18.1555 21.3567 17.9133 21.3567 17.6153V15.5972C21.3567 15.2991 21.1159 15.0569 20.8197 15.0569H18.8164C18.5201 15.0569 18.2793 14.8147 18.2793 14.5167V12.5402C18.2793 12.2422 18.0386 12 17.7423 12H14.2173C9.67928 12 6 15.7012 6 20.2663V20.7337C6 25.2988 9.67928 29 14.2173 29H25.463C25.7592 29 26 28.7578 26 28.4598V26.4833C26 26.1853 25.7592 25.9431 25.463 25.9431H14.2173V25.9421Z",
    fill: "url(#paint1_linear_45_35)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_35",
    x1: 15.8514,
    y1: 2.32794,
    x2: 42.1917,
    y2: 28.2064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4068EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_35",
    x1: 6.07806,
    y1: 12.1202,
    x2: 31.5208,
    y2: 37.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24F0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4068EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCloud32);
export default __webpack_public_path__ + "static/media/logo-cloud-32.6e08f9bcd27a3f4f0f01ca876513812c.svg";
export { ForwardRef as ReactComponent };